import React, { useMemo } from "react";
import Message from "./Message";
import { Divider } from "antd";
import moment from "moment";

function capitalize(s) {
    return s[0].toUpperCase() + s.slice(1);
}

function messageIsServerOpened(message) {
    /**
     * @type {import("Components/ChatHandler/ChatUtils/messageMeta").MessageMeta | undefined}
     */
    const meta = message.meta;

    if (!meta) return;
    if (meta.from !== "SERVER") return;
    if (!meta.payload) return;
    if (meta.payload.serverMessageType !== "OPENED") return;
    return true;
}

/**
 * Split messages by conversation. Each element in the return array are messages from one chat
 * @param {Array<any>} messages
 * @returns {Array<Array<any>>}
 */
function groupMessages(messages) {
    return messages.reduce((acc, currMsg) => {
        if (messageIsServerOpened(currMsg)) {
            return [...acc, [currMsg]];
        }
        const lastMessages = acc.length ? acc.pop() : [];
        return [...acc, [...lastMessages, currMsg]];
    }, []);
}
function ChatMessages(props) {
    const groupedMessages = useMemo(() => {
        if (!(props.messages && props.messages.length)) return;
        return groupMessages(props.messages);
    }, [props.messages]);

    const renderMessages = (messages, idx) => {
        if (!messages) return <></>;
        return (
            <>
                <Divider plain>
                    <div
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "1rem",
                            padding: "0 2rem",
                            color: "#aaa",
                        }}
                    >
                        {capitalize(
                            moment(messages[0].createdOn, "DD/MM HH:mm").format("dddd DD MMMM")
                        )}
                    </div>
                </Divider>
                {messages.map((message, index, list) => (
                    <Message
                        {...props}
                        prevMessage={list[index - 1]}
                        message={message}
                        key={message.id}
                        id={message.id}
                    />
                ))}
            </>
        );
    };

    return (
        <section className="section-chat">
            {groupedMessages?.map((messages, idx) => renderMessages(messages, idx))}
        </section>
    );
}
export default ChatMessages;
